import React from 'react';
import TextInput from '../../../components/Common/TextInput';

const MarksEntryFilter = ({
  showFilter,
  isCombinedMode,
  combinedOptions,
  handleCombinedChange,
  classOptions,
  streamOptions,
  subjectOptions,
  entryClass,
  entryStream,
  entryPaper,
  setEntryClass,
  setEntryStream,
  setEntryPaper,
  handleLoadStudents
}) => {
  if (!showFilter) return null;

  return (
    <div className={`slide-toggle ${showFilter ? 'open' : 'closed'} mb-3`}>
      <div className="card shadow-sm border-0">
        <div className="card-header bg-light d-flex align-items-center">
          <i className="fa fa-filter text-primary me-2"></i>
          <h6 className="mb-0">FILTER BY CLASS, STREAM & SUBJECT</h6>
        </div>
        <div className="card-body">
          <div className="row mb-3">
            {isCombinedMode ? (
              <>
                <div className="col-md-6">
                  <TextInput
                    label=""
                    placeholder="Select subject to start entering marks..."
                    type="select"
                    options={combinedOptions}
                    onChange={(item)=>handleCombinedChange(item.value)}
                    wrap
                    required
                  />
                </div>
                <div className="col-md-6">
                  <button className="btn btn-primary shadow-sm" onClick={handleLoadStudents}>
                    <i className="fa fa-users"></i> Load Students
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-4">
                  <TextInput
                    label="Class"
                    placeholder={entryClass ? entryClass.class_name : 'Select class'}
                    type="select"
                    options={classOptions}
                    onChange={(item) => setEntryClass(item.value)}
                    wrap
                    required
                  />
                </div>
                {streamOptions.length > 0 && (
                  <div className="col-md-4">
                    <TextInput
                      label="Stream"
                      placeholder={entryStream ? entryStream.label : 'Select stream'}
                      type="select"
                      options={streamOptions}
                      onChange={(item) => setEntryStream(item)}
                      wrap
                      required
                    />
                  </div>
                )}
                <div className="col-md-4">
                  <TextInput
                    label="Subject Paper"
                    placeholder={entryPaper ? entryPaper.label : 'Select subject paper'}
                    type="select"
                    options={subjectOptions}
                    onChange={(item) => setEntryPaper(item)}
                    wrap
                    required
                  />
                </div>
              </>
            )}
          </div>

          {!isCombinedMode && (
            <div className="text-end">
              <button className="btn btn-primary shadow-sm" onClick={handleLoadStudents}>
                <i className="fa fa-users"></i> Load Students
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarksEntryFilter;
